import React from 'react'
import AntCollapsePanel from 'antd/lib/collapse/CollapsePanel'
import './collapse-item.ant.scss'

const CollapseItem: typeof AntCollapsePanel = (props) => {
  return <AntCollapsePanel {...props} />
}

export default CollapseItem
